import { render, staticRenderFns } from "./Grocers.vue?vue&type=template&id=8500adae"
import script from "./Grocers.vue?vue&type=script&lang=js"
export * from "./Grocers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports